import * as React from "react";

export const SmartPhoneCheck = () => (
  <svg
    width={36}
    height={58}
    viewBox="0 0 36 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.108 6c.135-3.277 2.239-5 5-5h20.799c2.761 0 4.855 2.398 5.278 5.74.423 3.34 0 42.883 0 42.883 0 3.214-2.749 5.173-5.71 5.483-2.96.31-16.07.226-20.367 0-3.021-.158-5-3.44-5-6.201C1.683 31.83 1.974 9.277 2.108 6z"
      stroke="#000"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 7.982c.107-2.922 1.798-3.735 4.016-3.735h17.355c2.219 0 3.257 2.138 3.597 5.117.34 2.979-.226 38.572-.226 38.572 0 2.866-1.268 3.617-3.647 3.893-2.378.277-13.379.484-16.831.282-2.428-.141-4.11-2.05-4.11-4.512-.343-15.224-.263-36.695-.155-39.617z"
      stroke="#000"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.723 32.337l-4.346-4.927 4.337 3.794 7.35-8.876-7.34 10.009z"
      stroke="#000"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.299 50.657c0 1.688 2.018 4.842 5.611 5.492 7.82.492 12.152.47 19.78 0 2.725 0 5.683-2.758 5.683-5.492V7.547c0-2.733-2.32-6.754-5.08-6.485M34.485 12.7c.135 1.651.127 2.495 0 3.916M34.433 20.363c.07 1.569.031 2.422-.06 3.931M1.036 22.329c-.07-3.483-.03-5.376.06-8.727"
      stroke="#000"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.67 4.374c-.71.027-1.076 1.757-2.076 1.757-1.066.155-4.352.155-5.458 0-1.037 0-1.439-1.722-2.133-1.757M14.276 5.11h7.12M13.898 48.98c2.962.194 4.603.212 7.507.162"
      stroke="#000"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
